import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget';
import InsertTemplateSliderCommand from './template-slider-command';
export default class TemplateSliderEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertTemplateSlider', new InsertTemplateSliderCommand(this.editor));
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('templateSlider', {
            isObject: true,
            allowWhere: '$block',
        });
        schema.register('templateSliderCaption', {
            isLimit: true,
            allowIn: 'templateSlider',
            allowContentOf: '$block',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        // <templateSlider> converters
        conversion.for('upcast').elementToElement({
            model: 'templateSlider',
            view: 'x-template-slider',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'templateSlider',
            view: 'x-template-slider',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'templateSlider',
            view: (modelElement, { writer }) => {
                const div = writer.createContainerElement('div', {
                    class: 'template-slider',
                });
                return toWidget(div, writer, { label: 'template slider widget' });
            },
        });
        // <templateSliderCaption> converters
        conversion.for('upcast').elementToElement({
            model: 'templateSliderCaption',
            view: 'x-template-slider-caption',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'templateSliderCaption',
            view: 'x-template-slider-caption',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'templateSliderCaption',
            view: (modelElement, { writer }) => {
                const div = writer.createEditableElement('div', {
                    class: 'template-slider__caption',
                });
                return toWidgetEditable(div, writer);
            },
        });
    }
}
